import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import CheckIcon from './CheckIcon';
import styles from './styles.module.scss';

const StepsBar = ({ steps, currentStep }) => (
  <div className={styles.steps}>
    <ul className={styles.list}>
      {steps?.map((step, index) => (
        <li
          key={index}
          className={cn(
            styles.item,
            { [styles.done]: index + 1 < currentStep },
            { [styles.active]: index + 1 === currentStep }
          )}
        >
          <div className={styles.number}>
            {index + 1 < currentStep && <CheckIcon />}
            {index + 1 >= currentStep && step.label}
          </div>
          <div className={styles.description}>{step.description}</div>
        </li>
      ))}
    </ul>
  </div>
);

StepsBar.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
    })
  ).isRequired,
  currentStep: PropTypes.number.isRequired,
};

export default StepsBar;
